var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStress7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 590.96 335.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-73,.cls-8{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#ff3000;}.cls-4{fill:#ff9d00;}.cls-5{fill:#badd00;}.cls-6{fill:#00c85b;}.cls-7{fill:#ff9e00;}.cls-8{stroke:#053b5c;}.cls-73,.cls-8{stroke-miterlimit:10;stroke-width:2px;}.cls-10,.cls-27,.cls-33,.cls-49,.cls-9{fill:#053b5c;}.cls-10,.cls-20,.cls-27,.cls-33{font-size:18px;}.cls-10,.cls-20{font-family:Omnes-Medium, Omnes;font-weight:500;}.cls-11{letter-spacing:-0.02em;}.cls-12{letter-spacing:-0.01em;}.cls-13{letter-spacing:0em;}.cls-14{letter-spacing:0em;}.cls-15{letter-spacing:0em;}.cls-16{letter-spacing:0em;}.cls-17{letter-spacing:0em;}.cls-18{letter-spacing:-0.02em;}.cls-19{letter-spacing:-0.01em;}.cls-20,.cls-74{fill:#0093d9;}.cls-21{letter-spacing:0em;}.cls-22{letter-spacing:0em;}.cls-23{letter-spacing:-0.01em;}.cls-24{letter-spacing:0em;}.cls-25{letter-spacing:-0.02em;}.cls-26{letter-spacing:0em;}.cls-27,.cls-33,.cls-49{font-family:Omnes-Regular, Omnes;}.cls-27{letter-spacing:0em;}.cls-28{letter-spacing:0em;}.cls-29{letter-spacing:-0.02em;}.cls-30{letter-spacing:0em;}.cls-31{letter-spacing:0em;}.cls-32{letter-spacing:0em;}.cls-34{letter-spacing:0em;}.cls-35{letter-spacing:-0.01em;}.cls-36{letter-spacing:-0.01em;}.cls-37{letter-spacing:-0.01em;}.cls-38{letter-spacing:-0.01em;}.cls-39{letter-spacing:-0.01em;}.cls-40{letter-spacing:-0.02em;}.cls-41{letter-spacing:-0.01em;}.cls-42{letter-spacing:-0.01em;}.cls-43{letter-spacing:0em;}.cls-44{letter-spacing:-0.02em;}.cls-45{letter-spacing:-0.03em;}.cls-46{letter-spacing:0.02em;}.cls-47{letter-spacing:-0.01em;}.cls-48{letter-spacing:0em;}.cls-49{font-size:22px;}.cls-50{letter-spacing:-0.02em;}.cls-51{letter-spacing:-0.02em;}.cls-52{letter-spacing:-0.02em;}.cls-53{letter-spacing:-0.01em;}.cls-54{letter-spacing:0em;}.cls-55{letter-spacing:-0.02em;}.cls-56{letter-spacing:-0.01em;}.cls-57{letter-spacing:-0.02em;}.cls-58{letter-spacing:0em;}.cls-59{letter-spacing:0em;}.cls-60{letter-spacing:-0.01em;}.cls-61{letter-spacing:-0.01em;}.cls-62{letter-spacing:-0.01em;}.cls-63{letter-spacing:0em;}.cls-64{letter-spacing:0.02em;}.cls-65{letter-spacing:-0.03em;}.cls-66{letter-spacing:-0.01em;}.cls-67{letter-spacing:-0.01em;}.cls-68{letter-spacing:-0.01em;}.cls-69{letter-spacing:-0.01em;}.cls-70{letter-spacing:-0.01em;}.cls-71{letter-spacing:-0.05em;}.cls-72{letter-spacing:0.02em;}.cls-73{stroke:#0093d9;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M576.83,268.43c-131.25,0-131.25-208-262.5-208s-131.25,208-262.5,208Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "complete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M576.83,268.43c-131.25,0-131.25-208-262.5-208s-131.25,208-262.5,208",
    transform: "translate(0 -2.25)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.83,
    y: 58.17,
    width: 85,
    height: 208
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 136.83,
    y: 58.17,
    width: 75,
    height: 208
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 194.4,
    y: 58.17,
    width: 71.44,
    height: 208
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 265.58,
    y: 48.17,
    width: 95,
    height: 218
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 360.58,
    y: 58.17,
    width: 88.75,
    height: 208
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 449.33,
    y: 58.17,
    width: 127.5,
    height: 208
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "576.84 266.17 51.84 266.17 51.84 44.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "590.96 266.17 571.06 258.04 575.78 266.17 571.06 274.3 590.96 266.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "51.84 30.05 59.97 49.95 51.84 45.23 43.71 49.95 51.84 30.05"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(99.14 291.76)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 9.18,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.16,
    y: 0
  }, "w")), /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(0.56 247.31)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 9.18,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.16,
    y: 0
  }, "w")), /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(190.29 291.76)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13"
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 13.56,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 23.8,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 34.28,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 43.96,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 50.58,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 59.65,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 66.06,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-20",
    transform: "translate(148.74 60.17)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21"
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 4.65,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 15.14,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 24.74,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.06,
    y: 0
  }, "l "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 41.26,
    y: 0
  }, "Z"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 51.78,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 61.96,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 71.99,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-27",
    transform: "translate(63.75 214.45)"
  }, "B", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 10.94,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 20.98,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 26.72,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 36.26,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 46.44,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 56.48,
    y: 0
  }, "m")), /*#__PURE__*/React.createElement("text", {
    className: "cls-33",
    transform: "translate(496.27 214.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34"
  }, "B"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 10.92,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 20.6,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 26.57,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 36.29,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 46.3,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    x: 55.91,
    y: 0
  }, "t")), /*#__PURE__*/React.createElement("text", {
    className: "cls-33",
    transform: "translate(434.5 114.98)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40"
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 9.41,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42",
    x: 15.47,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 21.46,
    y: 0
  }, "ai"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.91,
    y: 0
  }, "n")), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M284.79,8.83a5.7,5.7,0,0,1,5.81-6.07c3.42,0,5.78,2.47,5.78,6a5.67,5.67,0,0,1-5.81,6.05C287.15,14.84,284.79,12.39,284.79,8.83Zm10.33,0c0-2.9-1.91-5-4.55-5s-4.52,2.05-4.52,5,1.91,5,4.55,5S295.12,11.74,295.12,8.83Z",
    transform: "translate(0 -2.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M298.54,17.61V6.11s.18-.13.39-.13c.4,0,.76.2.76,1.14V7.5a3.7,3.7,0,0,1,3.2-1.66c2.27,0,4.05,1.76,4.05,4.48s-1.74,4.52-4.12,4.52a3.56,3.56,0,0,1-3.11-1.64v4.41c0,.44-.22.56-.53.56h-.12C298.75,18.17,298.54,18.05,298.54,17.61Zm7.22-7.27c0-2-1.26-3.48-3-3.48a3.2,3.2,0,0,0-3.08,2v2a3,3,0,0,0,3,2.89C304.55,13.81,305.76,12.41,305.76,10.34Z",
    transform: "translate(0 -2.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M307.61,6.63V6.52c0-.3.13-.47.56-.47H309V4.56c0-.43.22-.56.52-.56h.13c.31,0,.5.13.5.56V6.05h2.29c.43,0,.56.17.56.47v.11c0,.31-.13.47-.56.47h-2.29V12c0,1.26.33,1.85,1.28,1.85a1.61,1.61,0,0,0,1.33-.63s.4.13.4.58-.63,1.06-1.76,1.06c-1.68,0-2.4-.95-2.4-2.74v-5h-.79C307.74,7.1,307.61,6.94,307.61,6.63Z",
    transform: "translate(0 -2.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M314.34,3.14a.7.7,0,0,1,.8-.78q.75,0,.75.78a.78.78,0,0,1-1.55,0Zm.18,11V6.54c0-.43.22-.56.53-.56h.12c.31,0,.52.13.52.56v7.6c0,.43-.21.56-.52.56h-.12C314.74,14.7,314.52,14.57,314.52,14.14Z",
    transform: "translate(0 -2.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M319.15,7.33a3.29,3.29,0,0,1,2.7-1.49,2.83,2.83,0,0,1,2.84,1.83,3.46,3.46,0,0,1,3.05-1.83c2.16,0,3.31,1.24,3.31,3.62v4.68c0,.43-.22.56-.52.56h-.13c-.31,0-.52-.13-.52-.56V9.53c0-1.71-.74-2.59-2.22-2.59a2.93,2.93,0,0,0-2.55,1.73v5.47c0,.43-.22.56-.53.56h-.12c-.31,0-.52-.13-.52-.56V9.62c0-1.8-.74-2.68-2.22-2.68a2.93,2.93,0,0,0-2.55,1.73v5.47c0,.43-.22.56-.53.56h-.12c-.31,0-.53-.13-.53-.56v-8s.19-.13.4-.13c.4,0,.76.2.76,1.14Z",
    transform: "translate(0 -2.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M332.75,12.43c0-2,2-2.83,6-2.92h.18v-.3a2.12,2.12,0,0,0-2.41-2.29,2.94,2.94,0,0,0-2.74,1.58.68.68,0,0,1-.66-.68c0-.61,1.22-2,3.49-2a3.14,3.14,0,0,1,3.48,3.33v5.4s-.18.13-.4.13c-.4,0-.74-.2-.74-1.14v-.32a3.79,3.79,0,0,1-3.2,1.58C333.83,14.82,332.75,13.87,332.75,12.43Zm6.14-1.21v-.79l-.5,0c-2.94.11-4.45.63-4.45,2,0,.86.7,1.42,1.87,1.42A2.79,2.79,0,0,0,338.89,11.22Z",
    transform: "translate(0 -2.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M342.32,14.14V2.49s.18-.13.39-.13c.4,0,.78.2.78,1.14V14.14c0,.43-.22.56-.53.56h-.12C342.53,14.7,342.32,14.57,342.32,14.14Z",
    transform: "translate(0 -2.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M265.81,31.74V21.26a.67.67,0,0,1,.68-.68h3c2.72,0,4.29,1.27,4.29,3.52s-1.52,3.59-4.43,3.59H267v4a.52.52,0,0,1-.54.56h-.16C266,32.3,265.81,32.12,265.81,31.74ZM267,26.61h2.41c2,0,3.07-.87,3.07-2.47s-1-2.47-3-2.47H267Z",
    transform: "translate(0 -2.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M274.78,28a4.31,4.31,0,0,1,4.32-4.54c2.41,0,4,1.71,4,4.32v.11c0,.32-.13.39-.49.39H276a3.17,3.17,0,0,0,3.26,3.14,3.07,3.07,0,0,0,2.93-1.53.68.68,0,0,1,.69.66c0,.6-1.3,1.91-3.62,1.91A4.26,4.26,0,0,1,274.78,28Zm1.21-.73h5.86a2.69,2.69,0,0,0-2.75-2.79A3.13,3.13,0,0,0,276,27.25Z",
    transform: "translate(0 -2.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M286,25.22a2.23,2.23,0,0,1,2.27-1.78c.79,0,1.24.32,1.24.88s-.29.65-.33.61a1.49,1.49,0,0,0-1-.36c-1.53,0-2.12,1.6-2.12,3.8v3.37c0,.43-.22.56-.53.56h-.12c-.31,0-.53-.13-.53-.56v-8s.19-.13.4-.13c.4,0,.76.2.76,1.14Z",
    transform: "translate(0 -2.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M290.32,24.23v-.11c0-.3.12-.47.55-.47h1.27v-.79c0-2,.86-3,2.52-3,1.15,0,1.71.48,1.71,1s-.31.59-.35.56a2,2,0,0,0-1.36-.53c-1,0-1.39.63-1.39,2.06v.73H295c.43,0,.56.17.56.47v.11c0,.31-.13.47-.56.47h-1.71v7c0,.43-.2.56-.51.56h-.12c-.31,0-.52-.13-.52-.56v-7h-1.27C290.44,24.7,290.32,24.54,290.32,24.23Z",
    transform: "translate(0 -2.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M296.14,27.92A4.42,4.42,0,1,1,305,28a4.42,4.42,0,1,1-8.84,0Zm7.65,0a3.24,3.24,0,1,0-6.47,0,3.29,3.29,0,0,0,3.24,3.49A3.25,3.25,0,0,0,303.79,28Z",
    transform: "translate(0 -2.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M307.9,25.22a2.23,2.23,0,0,1,2.27-1.78c.8,0,1.25.32,1.25.88s-.29.65-.33.61a1.51,1.51,0,0,0-1-.36c-1.53,0-2.13,1.6-2.13,3.8v3.37c0,.43-.21.56-.52.56h-.13c-.3,0-.52-.13-.52-.56v-8s.18-.13.4-.13c.39,0,.75.2.75,1.14Z",
    transform: "translate(0 -2.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M313.87,24.93a3.3,3.3,0,0,1,2.7-1.49,2.85,2.85,0,0,1,2.85,1.83,3.44,3.44,0,0,1,3-1.83c2.16,0,3.31,1.24,3.31,3.62v4.68c0,.43-.21.56-.52.56h-.12c-.31,0-.53-.13-.53-.56V27.13c0-1.71-.73-2.59-2.21-2.59a3,3,0,0,0-2.56,1.72v5.48c0,.43-.21.56-.52.56h-.13c-.3,0-.52-.13-.52-.56V27.22c0-1.8-.74-2.68-2.21-2.68a3,3,0,0,0-2.56,1.72v5.48c0,.43-.21.56-.52.56h-.13c-.3,0-.52-.13-.52-.56v-8s.18-.13.4-.13c.39,0,.75.2.75,1.14Z",
    transform: "translate(0 -2.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M327.48,30c0-2,2-2.83,6-2.92h.18V26.8a2.12,2.12,0,0,0-2.41-2.28,2.94,2.94,0,0,0-2.74,1.58.69.69,0,0,1-.67-.68c0-.61,1.23-2,3.5-2a3.13,3.13,0,0,1,3.47,3.33v5.4s-.18.13-.4.13c-.39,0-.73-.2-.73-1.14v-.32a3.81,3.81,0,0,1-3.21,1.58C328.56,32.42,327.48,31.47,327.48,30Zm6.14-1.21V28l-.51,0c-2.93.11-4.44.63-4.44,2,0,.86.7,1.42,1.87,1.42A2.8,2.8,0,0,0,333.62,28.82Z",
    transform: "translate(0 -2.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M338.15,25a3.37,3.37,0,0,1,2.92-1.56c2.26,0,3.4,1.51,3.4,3.78v4.52c0,.43-.22.56-.52.56h-.13c-.3,0-.52-.13-.52-.56V27.29c0-1.71-.85-2.75-2.31-2.75a3,3,0,0,0-2.82,1.81v5.39c0,.43-.22.56-.52.56h-.13c-.31,0-.52-.13-.52-.56v-8s.18-.13.39-.13c.4,0,.76.2.76,1.14Z",
    transform: "translate(0 -2.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M346.14,27.92a4.32,4.32,0,0,1,4.41-4.48c2.5,0,3.69,1.6,3.69,2.37,0,.53-.74.64-.77.56a2.9,2.9,0,0,0-2.92-1.89,3.24,3.24,0,0,0-3.22,3.44,3.26,3.26,0,0,0,3.22,3.48,2.9,2.9,0,0,0,2.92-1.89c0-.08.77,0,.77.55,0,.78-1.19,2.38-3.69,2.38A4.35,4.35,0,0,1,346.14,27.92Z",
    transform: "translate(0 -2.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M355.32,28a4.31,4.31,0,0,1,4.32-4.54c2.41,0,4,1.71,4,4.32v.11c0,.32-.13.39-.49.39h-6.66a3.17,3.17,0,0,0,3.26,3.14,3.07,3.07,0,0,0,2.93-1.53.68.68,0,0,1,.69.66c0,.6-1.3,1.91-3.62,1.91A4.26,4.26,0,0,1,355.32,28Zm1.21-.73h5.87a2.7,2.7,0,0,0-2.76-2.79A3.13,3.13,0,0,0,356.53,27.25Z",
    transform: "translate(0 -2.25)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-33",
    transform: "translate(116.8 114.98)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-43"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 11.91,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 21.95,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 37.03,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 42.4,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 52.44,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 58.82,
    y: 0
  }, "t")), /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(335.29 291.76)"
  }, "H", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-47",
    x: 12.33,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-48",
    x: 16.24,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.03,
    y: 0
  }, "h")), /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(0.97 66.98)"
  }, "H", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-47",
    x: 12.33,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-48",
    x: 16.24,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.03,
    y: 0
  }, "h")), /*#__PURE__*/React.createElement("text", {
    className: "cls-49",
    transform: "translate(236.61 330.12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-50"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 10.89,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-52",
    x: 22.16,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-53",
    x: 32.07,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 43.6,
    y: 0
  }, "l "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-55",
    x: 51.94,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 63.8,
    y: 0
  }, "f "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 74.8,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 86.72,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-58",
    x: 93.71,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-59",
    x: 105.29,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-60",
    x: 115.21,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 124.96,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 136.77,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 143.76,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-49",
    transform: "translate(0 17.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-63",
    x: 11.86,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-64",
    x: 23.45,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-65",
    x: 31.36,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-66",
    x: 37.9,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-67",
    x: 50.14,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-68",
    x: 57.42,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-69",
    x: 76.09,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-68",
    x: 87.04,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-70",
    x: 98.89,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 110.09,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(450.21 291.76)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-71"
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 10.3,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-72",
    x: 19.99,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 27,
    y: 0
  }, "y H"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-47",
    x: 51.35,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-48",
    x: 55.26,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    x: 64.04,
    y: 0
  }, "h")), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M179.32,147.93c2-3.2,4.1-6.41,6.18-9.6,4.26-6.54,8.62-13,13.14-19.33s9.19-12.43,14.09-18.26a198.47,198.47,0,0,1,15.41-16.51c12.66-12,26.05-21,40.35-26.94a118,118,0,0,1,45.84-8.86q5.44,0,10.72.43",
    transform: "translate(0 -2.25)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "188.62 144.95 180.69 143.62 176.13 136.99 172.94 155.77 188.62 144.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "318.56 53.4 322.58 46.42 320.35 38.69 336.89 48.17 318.56 53.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-73",
    x1: 217.64,
    y1: 71.48,
    x2: 228.14,
    y2: 81.98
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStress7);
export default __webpack_public_path__ + "static/media/stress7.b1397ca842774b99007ab25e13e787df.svg";
export { ForwardRef as ReactComponent };